import { useQuery } from "react-query";

import { makeRequest } from "@/util";
import FeatureFlag from "@/FeatureFlag";

export type AccountMetadataForManagementResponse = {
  config: Partial<Record<FeatureFlag, boolean>>;
  userFeatureFlagOverrides: string[];
};

export const ACCOUNT_METADATA_FOR_MANAGEMENT_QUERY_KEY =
  "useAccountMetadataForManagement";

export const useAccountMetadataForManagement = () => {
  return useQuery(ACCOUNT_METADATA_FOR_MANAGEMENT_QUERY_KEY, async () => {
    const { data } = await makeRequest<AccountMetadataForManagementResponse>(
      "account_metadata_for_management",
    );
    return data;
  });
};
